




















































































































































































































































































































































import _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { maskMoney, maskDate } from '@/utils/common'
import { IRequestMessage, RequestMessage, DataTableBackofficeProducaoPagination } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component
export default class ViewBackofficeProducao extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  loadBackofficeProducoes: boolean = false
  modalProcedimentos: boolean = false
  modalRecalcular: boolean = false
  loadShowProcedimentos: string = ''
  loadRecalcular: boolean = false
  loadSearch: boolean = false
  exp: boolean = false
  menuAnoMesReferencia: boolean = false
  menuDataRecebimento: boolean = false
  menuPrazo: boolean = false

  $refs!: {
    formRecalcularValores: any,
    menuAnoMesReferencia: any,
    menuDataRecebimento: any,
    menuPrazo: any,
  }

  recalcularValoresRules: any = {
    valid: true,
    dataAnoMesReferencia: [
      v => !!v || 'O campo é obrigatório.',
    ],
    dataRecebimento: [
      v => !!v || 'O campo é obrigatório.',
    ],
    prazo: [
      v => !!v || 'O campo é obrigatório.',
    ],
  }

  get search() {
    return this.getFinanceiroStore.search
  }

  set search(value: string) {
    this.getFinanceiroStore.setSearch(value)
  }

  get anoMesReferenciaRecalcularValores() {
    return this.getFinanceiroStore.anoMesReferenciaRecalcularValores
  }

  set anoMesReferenciaRecalcularValores(value) {
    this.getFinanceiroStore.setAnoMesReferenciaRecalcularValores(value)
  }

  get prazoRecalcularValores() {
    return this.getFinanceiroStore.prazoRecalcularValores
  }

  set prazoRecalcularValores(value) {
    this.getFinanceiroStore.setPrazoRecalcularValores(value)
  }

  get dataRecebimentoRecalcularValores() {
    return this.getFinanceiroStore.dataRecebimentoRecalcularValores
  }

  set dataRecebimentoRecalcularValores(value) {
    this.getFinanceiroStore.setDataRecebimentoRecalcularValores(value)
  }

  get getMenuDataRecebimento() {
    return this.menuDataRecebimento
  }

  set getMenuDataRecebimento(value: boolean) {
    this.menuDataRecebimento = value
  }

  get getMenuPrazo() {
    return this.menuPrazo
  }

  set getMenuPrazo(value: boolean) {
    this.menuPrazo = value
  }

  get getMenuAnoMesReferencia() {
    return this.menuAnoMesReferencia
  }

  set getMenuAnoMesReferencia(value: boolean) {
    this.menuAnoMesReferencia = value
  }

  get loadingRecalcular() {
    return this.loadRecalcular
  }

  set loadingRecalcular(value: boolean) {
    this.loadRecalcular = value
  }

  get loadingBackofficeProducoes() {
    return this.loadBackofficeProducoes
  }

  set loadingBackofficeProducoes(value: boolean) {
    this.loadBackofficeProducoes = value
  }

  get loadingSearch() {
    return this.loadSearch
  }

  set loadingSearch(value: boolean) {
    this.loadSearch = value
  }

  get loadingShowModalProcedimentos() {
    return this.loadShowProcedimentos
  }

  set loadingShowModalProcedimentos(value: string) {
    this.loadShowProcedimentos = value
  }

  get getPagina() {
    return this.getFinanceiroStore.paginaProducao
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPaginaProducao(value)
  }

  get showModalRecalcular() {
    return this.modalRecalcular
  }

  set showModalRecalcular(value: boolean) {
    this.modalRecalcular = value
  }

  openModalRecalcular() {
    this.modalRecalcular = true
  }

  closeModalRecalcular() {
    this.clearRecalcular()
    this.modalRecalcular = false
  }

  get expand() {
    return this.exp
  }

  set expand(value: boolean) {
    this.exp = value
  }

  get getTotal() {
    return this.getFinanceiroStore.totalBackofficeProducao || 0
  }

  get producaoLength() {
    return this.getFinanceiroStore.totalPageBackofficeProducao || 0
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headers() {
    return this.getFinanceiroStore.backofficeProducaoHeader
  }

  get backofficeProcedimentosHeader() {
    return this.getFinanceiroStore.backofficeProcedimentosHeader
  }

  get producaoItems() {
    return this.getFinanceiroStore.backofficeProducao
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get procedimentos() {
    return this.getFinanceiroStore.backofficeProcedimentos
  }

  formatMoneyUtil(money: string) {
    return maskMoney(money)
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  clearRecalcular() {
    this.$refs.formRecalcularValores.reset()
    this.$refs.formRecalcularValores.resetValidation()
    this.anoMesReferenciaRecalcularValores = ''
    this.prazoRecalcularValores = ''
    this.dataRecebimentoRecalcularValores = ''
  }

  debounce = _.debounce(input => this.getProducaoDebounce(input), 500)

  async searchDebounce(input) {
    this.debounce(input)
  }

  async getProducaoDebounce(input: string) {
    this.loadingSearch = true
    this.getFinanceiroStore.setBuscaProducao(input)
    await this.getFinanceiroStore.getBackofficeProducao()
    this.loadingSearch = false
  }

  async clearProducaoSearch(event: any) {
    if (event) {
      this.loadingSearch = true
      this.getFinanceiroStore.setBuscaProducao('')
      await this.getFinanceiroStore.getBackofficeProducao()
      this.loadingSearch = false
    }
  }

  async recalcular() {
    this.loadingRecalcular = true
    if (this.$refs.formRecalcularValores.validate()) {
      const response = await this.getFinanceiroStore.recalcular()
      if (response.status === 200) {
        EventBus.$emit('setSnackbar', { show: true, text: 'O cálculo está sendo gerado e você será notificado assim que for concluído!', icon: 'done', color: '#2E7D32' })
        this.clearRecalcular()
        this.modalRecalcular = false
      }
    }
    this.loadingRecalcular = false
  }

  async showModalProcedimentos(item: any) {
    this.loadingShowModalProcedimentos = item.medicoProducaoId
    await this.getFinanceiroStore.setBackofficeProcedimentos(item.procedimentos)
    this.modalProcedimentos = true
    this.loadingShowModalProcedimentos = ''
  }

  async closeModalProcedimentos() {
    this.getFinanceiroStore.clearBackofficeProcedimentos()
    this.modalProcedimentos = false
  }

  async getResults(pagina: number) {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.getPagina = pagina
    await this.getFinanceiroStore.getBackofficeProducao()
    EventBus.$emit('clearLoadingRequest')
  }

  async updatePagination(pagination: DataTableBackofficeProducaoPagination) {
    this.loadingBackofficeProducoes = true
    let param = ''
    if (pagination.sortBy) {
      param = pagination.descending ? `${pagination.sortBy}Desc` : `${pagination.sortBy}Asc`
    } else {
      param = ''
    }
    this.getFinanceiroStore.setSortBy(param)
    this.search = ''
    this.getFinanceiroStore.setBuscaProducao('')
    await this.getFinanceiroStore.getBackofficeProducao()
    this.loadingBackofficeProducoes = false
  }
}
